const LAZY_LOAD_VIEW = (path) => () =>
  import(
    /* webpackChunkName: "view-operations-location-alternatives-[request]" */ `@/views/pei/location-alternatives/${path}`
  );

export const LOCATION_ALTERNATIVES_ROUTES = [
  {
    path: 'location-alternatives',
    component: LAZY_LOAD_VIEW`layout/Wrapper.vue`,
    children: [
      {
        path: '',
        name: 'location-alternatives',
        component: LAZY_LOAD_VIEW`search/Main.vue`,
      },
      {
        path: 'manage/:schoolId-:academicYearId',
        props: ({ params }) => ({
          schoolId: +params.schoolId || 0,
          academicYearId: +params.academicYearId || 0,
        }),
        name: 'location-alternatives-manage',
        component: LAZY_LOAD_VIEW`manage/Main.vue`,
      },
      {
        path:
          'action-plan/:academicYearId/:schoolAlternativeLocationId?/:actionPlanId?',
        props: ({ params }) => ({
          academicYearId: +params.academicYearId || 0,
          schoolAlternativeLocationId: params.schoolAlternativeLocationId
            ? +params.schoolAlternativeLocationId
            : undefined,
        }),
        name: 'location-alternatives-action-plan',
        component: LAZY_LOAD_VIEW`manage/action-plan/Main.vue`,
      },
      {
        path:
          'action-plan-followup-history/:actionPlanId/:academicYearId/:isFromPrevious',
        props: ({ params }) => ({
          actionPlanId: +params.actionPlanId,
          academicYearId: +params.academicYearId,
          isFromPrevious: params.isFromPrevious === 'true',
        }),
        name: 'action-plan-followup-history',
        component: LAZY_LOAD_VIEW`search/actionPlan/followup-history/Main.vue`,
      },
    ],
  },
];
